import { useContext, useMemo } from 'react';

import { AppViewMode } from 'src/constants/uiConsts';
import { PortalConfigContext } from 'src/context/portalConfigContext';
import { UrlUtils } from 'src/utils';

export const useIsAssemblyBrandEnabled = () => {
  const portalConfig = useContext(PortalConfigContext);

  const isAssemblyDomain = useMemo<boolean>(
    () => UrlUtils.isAssemblyDomain(),
    [],
  );

  const isAssemblyBrandEnabled = useMemo<boolean>(
    () =>
      isAssemblyDomain ||
      portalConfig.viewMode === AppViewMode.INTERNAL ||
      portalConfig.isAssemblyBrandEnabled === true,
    [
      isAssemblyDomain,
      portalConfig.viewMode,
      portalConfig.isAssemblyBrandEnabled,
    ],
  );

  return {
    isAssemblyBrandEnabled,
  };
};
